<div class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div>{{ 'regep.tax-payment-declaration.title' | translate }}</div>
      <div class="section-buttons" *ngIf="sectionButtonsVisible() | async">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div class="form-background margin-align" [ngClass]="{ 'disable-section': getSectionLocked() && applicationId }">
    <div class="top-bottom-margin">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 bottom-padding">
            <p-radioButton
              name="is_payment_with_vat"
              [value]="true"
              [(ngModel)]="regulatoryData.is_payment_with_vat"
              (ngModelChange)="paymentWithVatChanged($event)"
              #is_payment_with_vat="ngModel"
              required
              [disabled]="isSectionDisabled"></p-radioButton>
            <label class="field-label">
              {{ 'regep.tax-payment-declaration.payment-including-vat' | translate }}
            </label>
          </div>
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12">
            <p-radioButton
              name="is_payment_with_vat"
              [value]="false"
              [(ngModel)]="regulatoryData.is_payment_with_vat"
              (ngModelChange)="paymentWithVatChanged($event)"
              #is_payment_with_vat="ngModel"
              required
              [disabled]="isSectionDisabled"></p-radioButton>
            <label class="field-label">
              {{ 'regep.tax-payment-declaration.payment-without-vat' | translate }}
            </label>
          </div>
        </div>

        <div *ngIf="showTaxInformation" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 bottom-padding">
            <label class="ui-g-5 field-label text-right-align required" for="tax_office">
              {{ 'regep.tax-payment-declaration.tax-office' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="regulatoryData.tax_office"
              name="tax_office"
              #tax_office="ngModel"
              required
              [disabled]="isSectionDisabled" />
          </div>

          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12">
            <label class="ui-g-5 field-label text-right-align required" for="tax_id">
              {{ 'regep.tax-payment-declaration.tax-id' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="regulatoryData.tax_id"
              name="tax_id"
              #tax_id="ngModel"
              required
              [disabled]="isSectionDisabled" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
